/**
 * Product Navigation JavaScript
 * Handles keyboard navigation and swipe gestures
 * 
 * FIXED: Now uses proper link elements for navigation
 */

(function() {
  'use strict';

  const dock = document.getElementById('product-nav-dock');
  if (!dock) return;

  const collectionHandle = dock.dataset.collection;
  const productHandle = dock.dataset.product;
  const position = parseInt(dock.dataset.position, 10);

  // Get prev/next links (now actual anchor elements)
  const prevLink = dock.querySelector('a.product-nav-edge--prev');
  const nextLink = dock.querySelector('a.product-nav-edge--next');
  
  // Mobile buttons
  const prevBtn = dock.querySelector('a.product-nav-btn--prev');
  const nextBtn = dock.querySelector('a.product-nav-btn--next');

  // ==========================================
  // Keyboard Navigation
  // ==========================================
  function handleKeydown(e) {
    // Don't trigger if user is typing in an input
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.isContentEditable) {
      return;
    }

    // Don't trigger if modal is open
    if (document.body.classList.contains('overflow-hidden')) {
      return;
    }

    // Get the best available link for navigation
    const prevUrl = prevLink?.href || prevBtn?.href;
    const nextUrl = nextLink?.href || nextBtn?.href;

    if (e.key === 'ArrowLeft' && prevUrl) {
      e.preventDefault();
      // Add visual feedback
      if (prevLink) prevLink.classList.add('product-nav-edge--active');
      window.location.href = prevUrl;
    } else if (e.key === 'ArrowRight' && nextUrl) {
      e.preventDefault();
      // Add visual feedback
      if (nextLink) nextLink.classList.add('product-nav-edge--active');
      window.location.href = nextUrl;
    }
  }

  document.addEventListener('keydown', handleKeydown);

  // ==========================================
  // Touch Swipe Detection (Mobile)
  // Only on the dock itself, not conflicting with gallery
  // ==========================================
  let touchStartX = 0;
  let touchStartY = 0;
  let touchEndX = 0;
  let touchEndY = 0;
  const minSwipeDistance = 80;

  function handleTouchStart(e) {
    touchStartX = e.changedTouches[0].screenX;
    touchStartY = e.changedTouches[0].screenY;
  }

  function handleTouchEnd(e) {
    touchEndX = e.changedTouches[0].screenX;
    touchEndY = e.changedTouches[0].screenY;
    handleSwipe();
  }

  function handleSwipe() {
    const diffX = touchEndX - touchStartX;
    const diffY = touchEndY - touchStartY;

    // Ensure horizontal swipe is dominant (not scrolling up/down)
    if (Math.abs(diffX) < minSwipeDistance || Math.abs(diffY) > Math.abs(diffX)) {
      return;
    }

    const prevUrl = prevBtn?.href || prevLink?.href;
    const nextUrl = nextBtn?.href || nextLink?.href;

    if (diffX > 0 && prevUrl) {
      // Swiped right -> go to previous
      window.location.href = prevUrl;
    } else if (diffX < 0 && nextUrl) {
      // Swiped left -> go to next
      window.location.href = nextUrl;
    }
  }

  // Only attach swipe to the navigation dock itself
  dock.addEventListener('touchstart', handleTouchStart, { passive: true });
  dock.addEventListener('touchend', handleTouchEnd, { passive: true });

  // ==========================================
  // Preloading Strategy
  // ==========================================
  function preloadNextPages() {
    // Preload images on hover (desktop)
    if (prevLink) {
      prevLink.addEventListener('mouseenter', () => {
        const img = prevLink.querySelector('.product-nav-preview img');
        if (img && !img.complete) {
          img.loading = 'eager';
        }
      });
    }
    
    if (nextLink) {
      nextLink.addEventListener('mouseenter', () => {
        const img = nextLink.querySelector('.product-nav-preview img');
        if (img && !img.complete) {
          img.loading = 'eager';
        }
      });
    }
  }

  preloadNextPages();

  // ==========================================
  // Analytics (if gtag available)
  // ==========================================
  function trackNavigation(direction, targetProduct) {
    if (typeof gtag === 'function') {
      gtag('event', 'product_navigation', {
        'event_category': 'engagement',
        'event_label': direction,
        'collection': collectionHandle,
        'from_product': productHandle,
        'to_product': targetProduct
      });
    }
  }

  // Track clicks on navigation links
  [prevLink, prevBtn].forEach(el => {
    if (el) {
      el.addEventListener('click', () => trackNavigation('previous', 'prev'));
    }
  });
  
  [nextLink, nextBtn].forEach(el => {
    if (el) {
      el.addEventListener('click', () => trackNavigation('next', 'next'));
    }
  });

  console.log('[ProductNav] Initialized for product:', productHandle, 'in collection:', collectionHandle, 'position:', position);
})();
